import { render, staticRenderFns } from "./perfectInfo.vue?vue&type=template&id=0747c675&scoped=true"
import script from "./perfectInfo.vue?vue&type=script&lang=js"
export * from "./perfectInfo.vue?vue&type=script&lang=js"
import style0 from "./perfectInfo.vue?vue&type=style&index=0&id=0747c675&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0747c675",
  null
  
)

export default component.exports